import React, {useState, useRef, useEffect} from 'react';
import './App.css';
import './TopButton.css';

const sendMessageToApp = (message) => {
  // iOS
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.reactNative) {
    window.webkit.messageHandlers.reactNative.postMessage(message);
  }
  // Android
  if (window.android) {
    window.android.postMessage(message);
  }
};

const TopButton = ({handleNewChat}) => {
  const handleNewChatClick = () => {
    console.log("点击了新对话");
    
    handleNewChat();
  };

  return (
    <div className="top-button-container">
      
      <button className="button-top" onClick={() => handleNewChatClick()}>
            <span className="icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M33 24C33 28.9706 28.9706 33 24 33C22.8029 33 21.6603 32.7663 20.6155 32.3419C20.4155 32.2607 20.3155 32.2201 20.2347 32.202C20.1557 32.1843 20.0972 32.1778 20.0161 32.1778C19.9333 32.1778 19.8431 32.1928 19.6627 32.2229L16.1048 32.8159C15.7322 32.878 15.5459 32.909 15.4112 32.8512C15.2933 32.8007 15.1993 32.7067 15.1488 32.5888C15.091 32.4541 15.122 32.2678 15.1841 31.8952L15.7771 28.3374C15.8072 28.1569 15.8222 28.0667 15.8222 27.9839C15.8222 27.9028 15.8157 27.8443 15.798 27.7653C15.7799 27.6845 15.7393 27.5845 15.6581 27.3845C15.2337 26.3397 15 25.1971 15 24C15 19.0294 19.0294 15 24 15C28.9706 15 33 19.0294 33 24Z" stroke="#191919" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M21 24H27" stroke="#191919" stroke-width="1.5" stroke-linecap="round"/>
                  <path d="M24 21L24 27" stroke="#191919" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
            </span>
        </button>
        <div style={{ fontSize: '16px', color: '#000', marginTop: '24px' }}>V2</div>
        <button className="button-top" onClick={() => sendMessageToApp('Close')}>
            <span className="icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.002 18.001L29.9994 29.9984" stroke="#191919" stroke-width="1.5" stroke-linecap="round"/>
                  <path d="M29.998 18.001L18.0006 29.9984" stroke="#191919" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
            </span>
        </button>
    </div>
  );
};

export default TopButton;
